import React from "react"

const Badge = ({ text }) => (
    <span className="flex rounded-full align-baseline items-center justify-center bg-red-200 px-1 ml-auto badged">
        <p className="text-red-600 text-base-14 font-bold px-1 badged2">{text}</p>
    </span>
)
export default Badge